import { roundButton as e } from "../styled/Composer.styled.mjs";
import { keyframes as t, styled as n } from "styled-components";
//#region src/components/Composer/components/ComposerSend.styled.ts
var r = t`
    from { transform: scale(0); }
    to { transform: scale(1); }
`, i = n.button`
    ${e};
    background: ${({ theme: e }) => e.colors.primary};
    color: ${({ theme: e }) => e.colors.primaryForeground};
    box-shadow: 0 4px 12px ${({ theme: e }) => e.colors.primary}66;
    animation: ${r} 0.3s cubic-bezier(0.2, 1, 0.3, 1.5);
    transition:
        background-color ${({ theme: e }) => e.transitions.fast},
        transform ${({ theme: e }) => e.transitions.fast};

    &:hover:not(:disabled) {
        background: ${({ theme: e }) => e.colors.primaryHover};
    }
    &:active:not(:disabled) {
        transform: scale(0.88);
    }
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;
//#endregion
export { i as SendButton };
